import {
  View,
  Text,
  useWindowDimensions,
  TouchableOpacity,
  ScrollView,
  TextInput,
  StyleSheet,
  ActivityIndicator,
} from "react-native";
import React, { useEffect, useState } from "react";
import { doc, getDocs, collection, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import Header from "../components/Header";
import { Image, Button } from "@rneui/base";
import { styles } from "../styles/mainStyle";
import EnuCollection from "../components/nuCollection";
import { useStateContext } from "../lib/context";
import { Cache } from "react-native-cache";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Ionicons } from "@expo/vector-icons";

const PRODUCTS_PER_PAGE = 24;
const UNWANTED_TYPE = "2 - K-C / R-C / T";
const CACHE_DATE_KEY = "CACHE_DATE";
const CACHE_ERO_KEY = "ERO";
const CACHE_DRN_KEY = "DRN";

const getTodayString = () => {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
};
const getCachePeriodString = () => {
  const d = new Date();
  const hours = d.getHours();
  const period = hours < 12 ? "AM" : "PM";
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}-${period}`;
};

const mapFirestoreProduct = (doc) => {
  // Map Firestore doc fields to the shape EnuCollection expects
  const data = doc.data();
  return {
    ARTICULO__ID: data.ARTICULO__ID || data.codigo || data.sku || "", // fallback for legacy fields
    DENOMINACION: data.DENOMINACION || data.nombre || data.producto || "",
    PRECIOVENTA: data.PRECIOVENTA || data.precio || 0,
    STOCK:
      data.STOCK !== undefined
        ? data.STOCK
        : data.stock !== undefined
          ? data.stock
          : 0,
    TIPO__ID: data.TIPO__ID || data.TIPO || data.tipo || "",
    // Add any other fields you need here
  };
};

const Home = ({ navigation, route }) => {
  // Initialize cache
  const cache = new Cache({
    namespace: "myapp",
    policy: {
      maxEntries: 50000,
      stdTTL: 0,
    },
    backend: AsyncStorage,
  });

  // Fetch cache on mount and check date
  useEffect(() => {
    const checkAndLoadCache = async () => {
      try {
        const cacheDateObj = await cache.get(CACHE_DATE_KEY);
        const cacheDate = cacheDateObj?.value || cacheDateObj;
        const currentPeriod = getCachePeriodString();
        // console.log("CACHE_DATE_KEY from cache:", cacheDateObj);
        // console.log("cacheDate used for comparison:", cacheDate);
        // console.log("currentPeriod from getCachePeriodString():", currentPeriod);

        if (cacheDate !== currentPeriod) {
          console.log("Cache period mismatch, clearing cache...");
          await cache.clearAll();
          await cache.set(CACHE_DATE_KEY, currentPeriod);
          setCacho({});
        } else {
          console.log("Cache period matches, loading cache...");
          const allCache = await cache.getAll();
          setCacho(allCache);
        }
      } catch (err) {
        console.log("Cache check error:", err);
        setCacho({});
      }
    };
    checkAndLoadCache();
  }, []);

  // Context
  const {
    setPromoEro,
    setPromoDrn,
    scroll,
    setUserID,
    setFullCurrentUser,
    setLastProd,
    setFullProducts,
    isViajante,
    currentUser,
  } = useStateContext();

  console.log("currentUser", currentUser);

  // State
  const [clienteEro, setClienteEro] = useState(null);
  const [clienteDrn, setClienteDrn] = useState(null);
  const [eroProducts, setEroProducts] = useState([]);
  const [drnProducts, setDrnProducts] = useState([]);
  const [nusearch, setNusearch] = useState("");
  const [productos, setProductos] = useState([]);
  const [cacho, setCacho] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [userHere, setUserHere] = useState("");
  const [bannerIndex, setBannerIndex] = useState(0);
  const [adminConfig, setAdminConfig] = useState([]);
  const [prodNovedades, setProdNovedades] = useState([]);
  const [prodOfertas, setProdOfertas] = useState([]);

  const mobileBanners = [
    require("../assets/eroban.jpg"),
    require("../assets/eroban.jpg"),
  ];
  const desktopBanners = [
    require("../assets/deskbanner.png"),
    require("../assets/deskbanner3.png"),
  ];

  // Responsive
  const { width } = useWindowDimensions();
  const isDesktop = width > 768;

  // Fetch cache on mount
  useEffect(() => {
    cache
      .getAll()
      .then(setCacho)
      .catch(() => setCacho({}));
  }, []);

  // Fetch ERO client data
  useEffect(() => {
    const fetchClienteEro = async () => {
      const emailToUse = isViajante ? route.params : auth.currentUser?.email;
      if (!emailToUse) return;
      try {
        const clean = emailToUse.replace("@mail.com", "");
        const docSnap = await getDoc(doc(db, "clientesero", clean));
        const data = docSnap.data();
        setClienteEro(data);
        setUserHere(data);
        setFullCurrentUser(data);
      } catch (err) {
        console.error("Error in fetchClienteEro:", err);
        setClienteEro(null);
        setError("Error fetching ERO client data");
      }
    };
    fetchClienteEro();
  }, []);

  // Fetch DRN client data
  useEffect(() => {
    const fetchClienteDrn = async () => {
      const emailToUse = isViajante ? route.params : auth.currentUser?.email;
      if (!emailToUse) return;
      try {
        const clean = emailToUse.replace("@mail.com", "");
        const docSnap = await getDoc(doc(db, "clientesdrn", clean));
        const data = docSnap.data();
        setClienteDrn(data);
      } catch (err) {
        setClienteDrn(null);
        setError("Error fetching DRN client data");
      }
    };
    fetchClienteDrn();
  }, []);

  // Fetch ERO products (from cache or Firestore)
  useEffect(() => {
    const fetchEroProducts = async () => {
      // console.log("Here's opn the home the info I've!!", clienteEro);
      if (!clienteEro) return;
      setPromoEro(clienteEro.PROMOCION__ID || null);
      setLoading(true);
      try {
        let products = [];

        if (cacho.ERO && Array.isArray(cacho.ERO.value)) {
          products = cacho.ERO.value;
          // console.log("ERO from cache", products);
        } else if (cacho.ERO && cacho.ERO.value) {
          // If it's a single object, wrap it in an array
          products = [cacho.ERO.value];
          // console.log("ERO from cache (single)", products);
        } else {
          // fetch from Firestore as fallback
          const lista = "erotarifa" + clienteEro.PRECIOS__ID;
          const querySnap = await getDocs(collection(db, lista));
          products = querySnap.docs.map(mapFirestoreProduct);
          await cache.set(CACHE_ERO_KEY, products);
          await cache.set(CACHE_DATE_KEY, getCachePeriodString());
          // console.log("ERO from Firestore", products);
        }

        setEroProducts(products);
      } catch (err) {
        setEroProducts([]);
        setError("Error fetching ERO products");
      } finally {
        setLoading(false);
      }
    };
    fetchEroProducts();
    // eslint-disable-next-line
  }, [clienteEro, cacho]);

  // Fetch DRN products (from cache or Firestore)
  useEffect(() => {
    const fetchDrnProducts = async () => {
      if (!clienteDrn) return;
      setPromoDrn(clienteDrn.PROMOCION__ID || null);
      setUserID(clienteDrn.COD__CLIENTE);
      setLoading(true);
      try {
        let products = [];
        if (cacho.DRN && Array.isArray(cacho.DRN.value)) {
          products = cacho.DRN.value;
          // console.log("DRN from cache", products);
        } else if (cacho.DRN && cacho.DRN.value) {
          products = [cacho.DRN.value];
          // console.log("DRN from cache (single)", products);
        } else {
          // fetch from Firestore as fallback
          const lista = "drntarifa" + clienteDrn.PRECIOS__ID;
          const querySnap = await getDocs(collection(db, lista));
          products = querySnap.docs.map(mapFirestoreProduct);
          await cache.set(CACHE_DRN_KEY, products);
          await cache.set(CACHE_DATE_KEY, getCachePeriodString());
          // console.log("DRN from Firestore", products);
        }
        setDrnProducts(products);
      } catch (err) {
        setDrnProducts([]);
        setError("Error fetching DRN products");
        // console.log("DRN fetch error", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDrnProducts();
    // eslint-disable-next-line
  }, [clienteDrn, cacho]);

  // Combine, filter, and set products for EnuCollection
  useEffect(() => {
    // Only show products with STOCK >= 1 and not unwanted type
    // console.log("no filter");
    // console.log(eroProducts);
    // console.log(drnProducts);
    const filtered = [...eroProducts, ...drnProducts].filter(
      (item) =>
        //  item.STOCK >= 1 &&
        item.TIPO__ID !== UNWANTED_TYPE &&
        item.ARTICULO__ID &&
        item.DENOMINACION,
    );
    setProductos(filtered);
    setLastProd(filtered);
  }, [eroProducts, drnProducts]);

  useEffect(() => {
    const fetchConfig = async () => {
      const docRef = doc(db, "AdminConfig", "main");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setAdminConfig(docSnap.data());
      } else {
        // docSnap.data() will be undefined in this case
        console.log("No such document!");
      }
    };
    fetchConfig();
  }, []);

  useEffect(() => {
    // Only run if both are loaded
    if (!Array.isArray(productos) || !adminConfig.Novedades) return;

    // Filter productos where ARTICULO__ID is in adminConfig.Novedades
    const filteredNovedades = productos.filter((prod) =>
      adminConfig.Novedades.includes(prod.ARTICULO__ID),
    );
    setProdNovedades(filteredNovedades);
    // console.log("novedades", filteredNovedades);

    // Same for Ofertas if needed
    const filteredOfertas = productos.filter((prod) =>
      adminConfig.Ofertas?.includes(prod.ARTICULO__ID),
    );
    setProdOfertas(filteredOfertas);
    // console.log("ofertas", filteredOfertas);
  }, [productos, adminConfig]);

  // Auto-advance banner
  useEffect(() => {
    const interval = setInterval(() => {
      setBannerIndex(
        (prev) =>
          (prev + 1) %
          (isDesktop ? desktopBanners.length : mobileBanners.length),
      );
    }, 4000); // 4 seconds per banner
    return () => clearInterval(interval);
  }, [isDesktop]);

  // UI
  return (
    <ScrollView
      style={localStyles.container}
      scrollEnabled={scroll}
      showsVerticalScrollIndicator={false}
    >
      <Header title={"Inicio"} navigation={navigation} isBack={false} />

      {/* Welcome Section */}
      <View style={localStyles.welcomeSection}>
        <Text style={localStyles.welcomeTitle}>Hola, {userHere.APELLIDO}!</Text>
        <Text style={localStyles.dateText}>
          {new Date().toLocaleDateString("es-AR", {
            weekday: "long",
            day: "numeric",
            month: "long",
          })}
        </Text>
      </View>

      {/* Action Cards */}
      {(clienteEro || clienteDrn) && productos.length > 0 && (
        <View style={localStyles.actionsContainer}>
          <TouchableOpacity
            style={localStyles.actionCard}
            onPress={() => navigation.navigate("Store", productos)}
          >
            <View
              style={[
                localStyles.iconContainer,
                { backgroundColor: "#E8EAF6" },
              ]}
            >
              <Ionicons name="cart" size={24} color="#2a2a8e" />
            </View>
            <Text style={localStyles.actionTitle}>Catálogo</Text>
            <Text style={localStyles.actionSubtitle}>Iniciá tu compra</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={localStyles.actionCard}
            onPress={() => navigation.navigate("Account", route.params)}
          >
            <View
              style={[
                localStyles.iconContainer,
                { backgroundColor: "#E0F2F1" },
              ]}
            >
              <Ionicons name="person" size={24} color="#00897B" />
            </View>
            <Text style={localStyles.actionTitle}>Mi Perfil</Text>
            <Text style={localStyles.actionSubtitle}>Datos de cuenta</Text>
          </TouchableOpacity>
        </View>
      )}

      {/* Banner */}
      <View style={localStyles.bannerContainer}>
        <Image
          source={
            isDesktop ? desktopBanners[bannerIndex] : mobileBanners[bannerIndex]
          }
          style={[
            localStyles.bannerImage,
            isDesktop && { height: 400, resizeMode: "contain" },
          ]}
        />
      </View>

      {/* Dolar Rate */}
      {adminConfig.Dolar && (
        <View style={localStyles.dolarCard}>
          <View style={localStyles.dolarContent}>
            <Ionicons name="cash-outline" size={24} color="#2E7D32" />
            <Text style={localStyles.dolarLabel}>Valor Dólar</Text>
          </View>
          <Text style={localStyles.dolarValue}>${adminConfig.Dolar}</Text>
        </View>
      )}

      {/* Version */}
      <Text style={localStyles.versionText}>ver.:1.1.7b</Text>

      {error && (
        <View style={localStyles.errorContainer}>
          <Ionicons name="alert-circle" size={20} color="#ff4444" />
          <Text style={localStyles.errorText}>{error}</Text>
        </View>
      )}

      {loading && (
        <View style={localStyles.loadingContainer}>
          <ActivityIndicator size="large" color="#2a2a8e" />
          <Text style={localStyles.loadingText}>Cargando productos...</Text>
        </View>
      )}

      {!loading && (
        <TouchableOpacity
          onPress={() => navigation.navigate("Store", productos)}
          style={localStyles.searchContainer}
          activeOpacity={0.9}
        >
          <View style={localStyles.searchWrapper}>
            <Ionicons name="search" size={20} color="#8F959E" />
            <TextInput
              onChangeText={(text) => setNusearch(text)}
              value={nusearch}
              style={localStyles.searchInput}
              placeholder="¿Qué estás buscando?"
              placeholderTextColor="#8F959E"
              editable={false} // Make it readonly since it navigates on press
              onPressIn={() => navigation.navigate("Store", productos)}
            />
          </View>
        </TouchableOpacity>
      )}

      {/* Sections */}
      {prodNovedades.length > 0 && (
        <View style={localStyles.section}>
          <View style={localStyles.sectionHeader}>
            <Text style={localStyles.sectionTitle}>Novedades</Text>
            <Ionicons name="flash" size={20} color="#FFD700" />
          </View>
          <EnuCollection
            products={prodNovedades}
            type={false}
            pagination={page}
            horizontal={true}
          />
        </View>
      )}

      {prodOfertas.length > 0 && (
        <View style={localStyles.section}>
          <View style={localStyles.sectionHeader}>
            <Text style={localStyles.sectionTitle}>Ofertas</Text>
            <Ionicons name="bookmark" size={20} color="#ff4444" />
          </View>
          <EnuCollection
            products={prodOfertas}
            type={false}
            pagination={page}
            horizontal={true}
          />
        </View>
      )}

      <View style={{ height: 100 }} />
    </ScrollView>
  );
};

export default Home;

const localStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6FD",
  },
  welcomeSection: {
    padding: 20,
    paddingBottom: 10,
  },
  welcomeTitle: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#2a2a8e",
  },
  dateText: {
    fontSize: 14,
    color: "#666",
    textTransform: "capitalize",
    marginTop: 4,
  },
  actionsContainer: {
    flexDirection: "row",
    paddingHorizontal: 20,
    gap: 15,
    marginBottom: 20,
  },
  actionCard: {
    flex: 1,
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 12,
  },
  actionTitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "#333",
    marginBottom: 4,
  },
  actionSubtitle: {
    fontSize: 12,
    color: "#999",
  },
  bannerContainer: {
    marginHorizontal: 20,
    marginBottom: 20,
    borderRadius: 16,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    backgroundColor: "#fff",
  },
  bannerImage: {
    width: "100%",
    height: 180,
    resizeMode: "cover",
  },
  dolarCard: {
    marginHorizontal: 20,
    backgroundColor: "#E8F5E9",
    borderRadius: 12,
    padding: 16,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#C8E6C9",
    marginBottom: 10,
  },
  dolarContent: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  dolarLabel: {
    fontSize: 16,
    fontWeight: "600",
    color: "#2E7D32",
  },
  dolarValue: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#1B5E20",
  },
  versionText: {
    textAlign: "center",
    fontSize: 12,
    color: "#aaa",
    marginBottom: 20,
  },
  searchContainer: {
    marginHorizontal: 20,
    marginBottom: 24,
  },
  searchWrapper: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: 12,
    paddingHorizontal: 16,
    height: 50,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
    borderWidth: 1,
    borderColor: "#eee",
  },
  searchInput: {
    flex: 1,
    marginLeft: 10,
    fontSize: 16,
    color: "#333",
  },
  section: {
    marginBottom: 24,
    paddingHorizontal: 20,
  },
  sectionHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 16,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#333",
  },
  loadingContainer: {
    padding: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  loadingText: {
    marginTop: 12,
    color: "#666",
    fontSize: 16,
  },
  errorContainer: {
    margin: 20,
    padding: 16,
    backgroundColor: "#ffebee",
    borderRadius: 12,
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  errorText: {
    color: "#ff4444",
    flex: 1,
  },
});
